//hasExpired 1是到期和快到期
import React, { Component } from "react";
import {
  NavBar,
  Icon,
  List,
  SearchBar,
  Radio,
  Button,
  WhiteSpace,
  Checkbox,
  Toast,
  Pagination,
  WingBlank,
  ActionSheet,
  Popover,
} from "antd-mobile";
import { Link } from "react-router-dom";
import { connect } from "dva";
import "./userList.scss";
import axios from "../../../../service/axios";
import Search from "../../../../components/search/search";
import NoneDatas from "../../../../components/noneDatas";
import ImMeassage from "../../../../components/imMessage/imMessage";
// import SetDefaultGroup from "./setDefaultGroup";
// import BatchModifyUser from "./batchModifyUser";
const more_icon = require("../../../../assets/images/icon/more_icon.png");
const im_icon = require("../../../../assets/images/icon/im_icon.svg");
const modify_icon = require("../../../../assets/images/icon/modify_icon.svg");
const plus_icon = require("../../../../assets/images/icon/plus_icon.png");
const Item = List.Item;
const Brief = Item.Brief;
const CheckboxItem = Checkbox.CheckboxItem;
const RadioItem = Radio.RadioItem;
const selectedContainer = {
  position: "fixed",
  width: "100%",
  top: "45px",
  background: "#f5f5f5",
  height: "100%",
  zIndex: "11",
  transition: "left 0.4s",
};
@connect(({ enterpriseuser }) => ({ enterpriseuser }))
export class UserList extends Component {
  state = {
    userDatas: [],
    pageTotalNum: 0,
    pageNo: 1,
    showCheck: false,
    selectItem: [],
    drawerLeft: document.body.clientWidth,
    drawerSearch: document.body.clientWidth,
    drawerImMessage: document.body.clientWidth,
    drawerLeftDefault: document.body.clientWidth,
    drawerLeftModifyUser: document.body.clientWidth,
    billList: [],
    selectBillId: null,
    searchKey: {},
    visible: false,
    imKey: 100,
    defaultGroupKey: 100,
    validFlag: false,
    tag: false
  };
  componentDidMount() {
    this.getUserList(
      sessionStorage.getItem("userListPage")
        ? sessionStorage.getItem("userListPage")
        : 1,
    );
  }

  getUserList(e) {
    Toast.loading("加载中...", 0);
    axios
      .post("/api/enterprise/user/page", {
        page: {
          pageSize: 10,
          pageNo: e,
        },
        owner: null,
        ...this.state.searchKey,
      })
      .then(res => {
        console.log(res);
        if (res && res.status == 200) {
          document.querySelector("#root").scrollTop = 0;
          this.setState({
            userDatas: res.data || [],
            pageTotalNum: Math.ceil(res.total / 10),
            pageNo: e || 1,
          });
        } else {
          this.setState({
            userDatas: [],
          });
          Toast.fail("获取列表失败，请稍后再试");
        }
      });
  }
  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }
  onPageChange(e) {
    const { pageTotalNum } = this.state;
    e = e > pageTotalNum ? pageTotalNum : e;
    console.log(e);
    this.getUserList(e);
    this.setState({
      selectItem: [],
    });
    sessionStorage.setItem("userListPage", e);
  }
  onItemChange(e, i) {
    let arr = [...this.state.selectItem];
    if (e.target.checked) {
      arr.push(i);
      this.setState({
        selectItem: arr,
      });
    } else {
      arr.splice(arr.map(item => item.uid).indexOf(i.uid), 1);
      this.setState({
        selectItem: arr,
      });
    }
  }
  actionBtn(e) {
    const { selectItem } = this.state;
    console.log(selectItem);
    if (selectItem.length < 1) {
      Toast.fail("请选择要操作的用户！", 1);
      return;
    }
    let action;
    let message;
    if (e == 1) {
      if (this.state.selectItem.map(item => item.hasExpired).indexOf(1) >= 0) {
        Toast.info("不能删除过期用户", 1);
        return;
      }
    }
    switch (e) {
      case 1:
        action = "delete";
        message = "确认删除选中的用户？";
        break;
      case 2:
        action = "activation";
        message = "确认激活选中的用户？";
        break;
      case 3:
        action = "suspend";
        message = "确认暂停选中的用户？";
        break;
      case 4:
        action = "renew";
        message = "确认续费选中的用户？";
        break;
      default:
        break;
    }
    const BUTTONS = ["确定", "取消"];
    ActionSheet.showActionSheetWithOptions(
      {
        options: BUTTONS,
        cancelButtonIndex: 1,
        destructiveButtonIndex: 0,
        message: message,
        maskClosable: true,
      },
      buttonIndex => {
        console.log(buttonIndex);
        if (!buttonIndex) {
          Toast.loading("加载中...", 0);
          axios
            .post("/api/user/ptt/" + action, {
              uids: this.state.selectItem.map(item => item.uid),
            })
            .then(res => {
              Toast.hide();
              if (res) {
                if (res.status == 200) {
                  Toast.success("操作成功", 1);
                  setTimeout(() => {
                    this.getUserList(this.state.pageNo);
                    this.setState({
                      selectItem: [],
                    });
                  }, 1000);
                } else {
                  Toast.fail(res.message, 1);
                }
              }
            })
            .catch(() => {
              Toast.fail("操作失败", 1);
            });
        } else {
        }
      },
    );
    return;
  }
  showRenewDrawer() {
    const {selectItem} = this.state
    console.log('勾选的用户',selectItem)
    if (selectItem.length < 1) {
      Toast.fail("请选择要操作的用户！", 1);
      return;
    }
    // 账号类型 判断 oldType [0为三年期,1为绑定三级管理员的特殊账号,4为终身,6为三年拆分一年,7为终身拆分一年,8为其他类型预留的]
    const oneYearAccountList = selectItem.filter(item => item.oldType == 6)
    const lifelongAccountList = selectItem.filter(item => item.oldType == 4)
    const lifelong2AccountList = selectItem.filter(item => item.oldType == 7)
    if (oneYearAccountList.length != 0 && oneYearAccountList.length != selectItem.length) {
      Toast.info('请选择相同类型账号!')
    } else if (lifelongAccountList.length != 0 ) {
      Toast.info('终身账号不能续费!')
    } else if (lifelong2AccountList.length != 0 ) {
      Toast.info('终身账号不能续费!')
    } else {
      console.log('开续')
      // this.setState({
      //   drawerLeft: 0,
      // });
      this.props.history.push({
        pathname: '/BatchUserRenew',
        query: {
          userData: selectItem
        }
      })
    }
  }
  // 批量续费提交
  pttUserRenew() {
    if (this.state.selectItem.length < 1) {
      Toast.fail("请选择要操作的用户！", 1);
      return;
    }
    console.log('批量提交?',this.state.selectItem)
    //判断账号的续费类型（0：虚拟币续费，1：续费币续费）
    const rtype = this.state.selectItem[0].oldType == 6 ? 1 : 0
    // 参数
    let payload = {
      uids: [],
      fgids: [],
      validFlag: this.state.validFlag,
      tag: false
    }
    // 账号类型展示
    if(rtype == 0) {
      // 虚拟币续费
      
      axios.post(
        "/api/user/ptt/renewBatchByCurrency",
        payload
      ).then(res =>{

      })
    } else {
      // 续费币续费
      axios.post(
        "/api/user/ptt/renewBatchByCurrency",
        payload
      ).then(res => {

      })
    }
    
    // if (!this.state.selectBillId) {
    //   Toast.fail("请选择续费的账单", 1);
    //   return;
    // }
    // Toast.loading("加载中...", 0);
    // axios
    //   .post("/api/user/ptt/repay", {
    //     uids: this.state.selectItem.map(item => item.uid),
    //     billid: this.state.selectBillId,
    //   })
    //   .then(res => {
    //     Toast.hide();
    //     if (res && res.status == 200) {
    //       Toast.success(res.message, 1);
    //       setTimeout(() => {
    //         this.getUserList(this.state.pageNo);
    //         this.setState({
    //           drawerLeft: document.body.clientWidth,
    //         });
    //       }, 1000);
    //     } else {
    //       Toast.fail(res.message, 1);
    //     }
    //   })
    //   .catch(() => {
    //     Toast.fail("操作失败");
    //   });
  }
  //搜索结果赋值给billList
  onSearchList = e => {
    console.log(e);
    this.setState({
      searchKey: {
        ...e,
      },
      drawerSearch: document.body.clientWidth,
    });
    setTimeout(() => {
      this.getUserList(1);
    }, 0);
  };
  openImMessage() {
    if (this.state.selectItem < 1) {
      Toast.info("请选择用户", 1);
      return;
    }
    this.setState({
      imKey: this.state.imKey == 100 ? 111 : 100,
      drawerImMessage: 0,
    })
  };
  sendUserMessage(messages) {
    axios.post("/api/mqtt/server/user/send", {
      uids: this.state.selectItem.map(item => item.uid),
      messages,
    }).then(res => {
      if (res.status == 200) {
        Toast.info("发送成功", 1);
      } else {
        Toast.fail(res.message);
      }
    });
  };
  modifyDefaultGroup() {
    if (this.state.selectItem < 1) {
      Toast.info("请选择用户", 1);
      return;
    }
    this.setState({
      defaultGroupKey: this.state.defaultGroupKey == 100 ? 111 : 100,
      drawerLeftDefault: 0,
    })
  };
  modifyUserInfo() {
    if (this.state.selectItem < 1) {
      Toast.info("请选择用户", 1);
      return;
    }
    this.setState({
      drawerLeftModifyUser: 0,
    })
  };
  onSelect = (opt) => {
    const selected = opt.props.value;
    if ('message' == selected) {
      this.openImMessage();
    } else if ('group' == selected) {
      this.modifyDefaultGroup();
    } else {
      this.modifyUserInfo();
    }
    this.setState({
      visible: false,
    });
  };
  handleVisibleChange = (visible) => {
    this.setState({
      visible,
    });
  };

  render() {
    const {
      pageNo,
      pageTotalNum,
      showCheck,
      selectItem,
      userDatas,
      drawerLeft,
      billList,
      selectBillId,
      drawerSearch,
      drawerImMessage,
      drawerLeftDefault,
      drawerLeftModifyUser,
      tag,
      validFlag,
    } = this.state;
    const userMsg =
      sessionStorage.getItem("loginMsg") &&
      JSON.parse(sessionStorage.getItem("loginMsg"));

    const UserActions = () => (
      <div>
        <div className="am-list-header">已选择需要续费的用户</div>
        <List style={{ height: "20%", overflowY: "scroll" }}>
          {selectItem.map((item, index) => (
            <Item key={index}>{item.account} - {item.name}</Item>
          ))}
        </List>
        <WhiteSpace />
        <WingBlank>
          <Button type="primary" onClick={() => this.pttUserRenew()}>
            确认续费
          </Button>
          <WhiteSpace />
          <Button
            onClick={() =>
              this.setState({
                drawerLeft: document.body.clientWidth,
              })
            }
          >
            返回
          </Button>
        </WingBlank>
      </div>
    );

    const ItemList = ({ item }) => (
      <div>
        {item.account} (
        {item.onLine == 1 ? (
          "离线"
        ) : (
            <span style={{ color: "#0078D7" }}>在线</span>
          )}
        )
        {item.hasExpired == 1 ? (
          <span style={{ color: "red", margin: "0 10px" }}>账号过期请续费</span>
        ) : (
            ""
          )}
        {item.hasExpired != 1 && item.usrType == 2 ? (
          <span style={{ color: "red", margin: "0 10px" }}>续费账户</span>
        ) : (
            ""
          )}
        {item.hasExpired != 1 && item.usrType == 3 ? (
          <span style={{ color: "red", margin: "0 10px" }}>VIP续费账户</span>
        ) : (
            ""
          )}
        <Brief>
          <span>
            ID:
            {item.uid}{" "}
          </span>
          &ensp;&ensp;
          <span>
            名字：
            {item.name}
          </span>{" "}
        </Brief>
        <Brief>
          <span>
            状态：
            {item.usrValid == 2 ? (
              <span style={{ color: "#00e000" }}>激活</span>
            ) : (
                <span style={{ color: "#c3c300" }}>暂停</span>
              )}
          </span>
          &ensp;&ensp;
          <span>
            有效期：
            {item.validDate}{" "}
          </span>
          {userMsg.preferentialMonths > 0 ? (<span>
            &ensp;&ensp;
            类型：
            {item.oldType == 6 ? '优惠' : item.oldType == 4 ? '终身' :item.oldType == 7 ? 'B型优惠' :'三年' }
          </span>) : ('')}
        </Brief>
      </div>
    );

    return (
      <div className="user-list">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.goBack()}
            rightContent={[
              showCheck ? (
                <Icon
                  onClick={() => {
                    this.setState({
                      showCheck: false,
                      selectItem: [],
                    });
                  }}
                  key="1"
                  type="cross"
                />
              ) : (
                    <div key="2">
                      <Icon
                        type="search"
                        size="sm"
                        key="1"
                        onClick={() =>
                          this.setState({
                            drawerSearch: 0,
                          })
                        }
                      />
                      &ensp;
                      <Link to="/enterpriseGroupAdd" key="1">
                        <img src={plus_icon} width="24" />,
                      </Link>
                      &ensp; 
                      <img
                        key="2"
                        style={{ width: 22 }}
                        onClick={() => {
                          this.setState({
                            showCheck: true,
                            selectNum: 0,
                          });
                        }}
                        src={more_icon}
                      />
                    </div>
                  ),
            ]}
          >
            用户列表
          </NavBar>
        </div>
        <div className="sub-container">
          <WhiteSpace />
          {userDatas.map((item, index) => {
            return (
              <div key={index} style={{ borderBottom: "1px solid #e8e8e8" }}>
                {showCheck ? (
                  <CheckboxItem
                    key={index}
                    checked={selectItem
                      .map(item => item.uid)
                      .includes(item.uid)}
                    onChange={e => this.onItemChange(e, item)}
                    style={
                      item.type == 1 ? { background: "#e6e6e6" } : {}
                      // item.hasExpired == 1 ? { background: "#e6e6e6" } : {}
                    }
                  >
                    <ItemList item={item} />
                  </CheckboxItem>
                ) : (
                    <Item
                      arrow="horizontal"
                      multipleLine
                      onClick={() =>
                        this.props.history.push(`/adduser/${item.uid}/edit`)
                      }
                      key={index}
                      style={item.type == 1 ? { background: "#e6e6e6" } : {}}
                    >
                      <ItemList item={item} />
                    </Item>
                  )}
              </div>
            );
          })}
          {userDatas.length == 0 ? <NoneDatas /> : ""}
          <WhiteSpace />
          <WingBlank>
            <SearchBar
              placeholder="请输入跳转页面"
              onSubmit={value => this.onPageChange(value)}
            />
          </WingBlank>
          <WhiteSpace />
          <WingBlank>
            {pageTotalNum > 0 ? (
              <Pagination
                total={pageTotalNum}
                current={pageNo}
                locale={{
                  prevText: "上一页",
                  nextText: "下一页",
                }}
                onChange={e => this.onPageChange(e)}
              />
            ) : (
                ""
              )}
          </WingBlank>

          {showCheck ? (
            <div className="footer">
              {/* <Button
                type="primary"
                inline
                size="small"
                onClick={() => this.actionBtn(1)}
              >
                删除
              </Button> */}
              <Button
                type="primary"
                inline
                size="small"
                onClick={() => this.actionBtn(2)}
              >
                激活
              </Button>
              <Button
                type="primary"
                inline
                size="small"
                onClick={() => this.actionBtn(3)}
              >
                暂停
              </Button>
              <Button
                type="primary"
                inline
                size="small"
                onClick={() => this.showRenewDrawer()}
              >
                续费
              </Button>
              <Popover
                overlayClassName="fortest"
                overlayStyle={{ color: 'currentColor' }}
                visible={this.state.visible}
                placement="topRight"
                overlay={[
                  // (<Popover.Item key="1" value="message" icon={<img src={im_icon} className="am-icon am-icon-xs" alt="" />}>
                  //   发送通知
                  // </Popover.Item>),
                  // (<Popover.Item key="2" value="group" icon={<img src={modify_icon} className="am-icon am-icon-xs" alt="" />}>
                  //   修改默认群组
                  // </Popover.Item>),
                  (<Popover.Item key="3" value="info" icon={<img src={modify_icon} className="am-icon am-icon-xs" alt="" />}>
                    批量修改信息
                  </Popover.Item>),
                ]}
                align={{
                  overflow: { adjustY: 0, adjustX: 0 },
                  offset: [-10, 0],
                }}
                onVisibleChange={this.handleVisibleChange}
                onSelect={this.onSelect}
              >
                <div style={{
                  height: '100%',
                  padding: '0 15px',
                  marginRight: '-15px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                >
                  <Icon type="ellipsis" />
                </div>
              </Popover>
            </div>
          ) : (
              ""
            )}
          <div
            className="renew"
            style={{ ...selectedContainer, left: drawerLeft }}
          >
            <UserActions />
          </div>
          <div
            className="search"
            style={{ ...selectedContainer, left: drawerSearch }}
          >
            <Search
              closeSearch={() =>
                this.setState({
                  drawerSearch: document.body.clientWidth,
                })
              }
              type="user"
              onSearchList={this.onSearchList}
            />
          </div>
          <div className="im" style={{ ...selectedContainer, left: drawerImMessage }}>
            <ImMeassage
              key={this.state.imKey}
              ids={this.state.selectItem.map(item => item.uid)}
              sendMessage={e => this.sendUserMessage(e)}
              closeIm={() =>
                this.setState({
                  drawerImMessage: document.body.clientWidth,
                })}
              type="user"
            />
          </div>

          
          {/* <div 
            style={{
              ...selectedContainer,
              left: drawerLeftDefault + "px",
              overflowY: "scroll",
              paddingBottom: "45",
            }}
          >
            <SetDefaultGroup
              key={this.state.defaultGroupKey}
              uids={this.state.selectItem.map(item => item.uid)}
              handleChildClose={() => {
                this.setState({
                  drawerLeftDefault: document.body.clientWidth,
                });
              }}
            />
          </div>
          <div
            style={{
              ...selectedContainer,
              left: drawerLeftModifyUser + "px",
              overflowY: "scroll",
              paddingBottom: "45",
            }}
          >
            <BatchModifyUser
              userList={this.state.selectItem}
              handleChildClose={() => {
                this.setState({
                  drawerLeftModifyUser: document.body.clientWidth,
                });
              }}
            />
          </div> */}
        </div>
      </div>
    );
  }
}

export default UserList;
